module.exports = __webpack_public_path__ + "img/landing1.407dde61.jpg";